import PopupMenuRowWithToggle from '@osmosis/nextjs-components/PopupMenu/PopupMenuRowWithToggle';
export * from '@osmosis/nextjs-components/PopupMenu/PopupMenuRowWithToggle';
export default PopupMenuRowWithToggle;
